<template>
  <span
    class="app-svg-icon"
    :style="iconStyle"
    :role="label ? 'img' : undefined"
    :aria-label="label || undefined"
    :aria-hidden="label ? undefined : 'true'"
  ></span>
</template>

<script setup lang="ts">
import { computed, type CSSProperties } from 'vue'

const props = withDefaults(
  defineProps<{
    src: string
    size?: number | string
    label?: string
  }>(),
  {
    size: 20,
    label: '',
  },
)

const iconSize = computed(() =>
  typeof props.size === 'number' ? `${props.size}px` : props.size,
)

const iconStyle = computed<CSSProperties>(
  () =>
    ({
      '--app-svg-icon-url': `url("${props.src}")`,
      '--app-svg-icon-size': iconSize.value,
    }) as CSSProperties,
)
</script>

<style scoped lang="scss">
.app-svg-icon {
  display: inline-block;
  width: var(--app-svg-icon-size);
  height: var(--app-svg-icon-size);
  flex: 0 0 auto;
  background-color: currentcolor;
  mask: var(--app-svg-icon-url) center / contain no-repeat;
  -webkit-mask: var(--app-svg-icon-url) center / contain no-repeat;
}
</style>
